import React from 'react';
import './WhoWeServe.css';
import installationImage from '../assets/man_installing_electrical.jpeg';

// Define the industry types with descriptions
const industries = [
  {
    id: 'hightech',
    name: 'High Tech',
    icon: '💻',
    description: 'Advanced electrical solutions for tech companies'
  },
  {
    id: 'publicworks',
    name: 'Public Works',
    icon: '🏛️',
    description: 'Reliable infrastructure for government facilities'
  },
  {
    id: 'healthcare',
    name: 'Healthcare',
    icon: '🏥',
    description: 'Critical power systems for medical facilities'
  },
  {
    id: 'retail',
    name: 'Retail',
    icon: '🛒',
    description: 'Custom lighting and power for retail spaces'
  },
  {
    id: 'biotech',
    name: 'Biotech/Pharmaceutical',
    icon: '🧬',
    description: 'Specialized electrical systems for labs'
  },
  {
    id: 'commercial',
    name: 'Commercial',
    icon: '🏢',
    description: 'Complete electrical solutions for offices'
  },
  {
    id: 'industrial',
    name: 'Industrial',
    icon: '🏭',
    description: 'Heavy-duty electrical for manufacturing'
  },
  {
    id: 'education',
    name: 'Education',
    icon: '🎓',
    description: 'Safe and efficient systems for schools'
  }
];

const WhoWeServe: React.FC = () => {
  return (
    <section id="who-we-serve" className="who-we-serve-section">
      <div className="container">
        <div className="section-header">
          <h2>Who We Serve</h2>
          <p className="section-intro">
            Over our 25 years of experience we have completed a wide variety of projects.
            Our experience covers a large spectrum of jobs including:
          </p>
        </div>

        <div className="industries-grid">
          {industries.map((industry) => (
            <div key={industry.id} className="industry-card">
              <div className="industry-icon">{industry.icon}</div>
              <div className="industry-content">
                <h3 className="industry-title">{industry.name}</h3>
                <p className="industry-description">{industry.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="experience-highlight">
          <span className="experience-years">25+</span>
          <span className="experience-text">Years of Industry Experience</span>
        </div>
      </div>
    </section>
  );
};

export default WhoWeServe; 